import { type GetServerSideProps, type NextPage } from "next";
import { Layout } from "~/components/Layout/Layout";
import { TierMembershipOption } from "~/components/Plans/TierMembershipOption";
import { Private } from "~/components/Private";
import { EventNames } from "~/mixpanel/EventNames";
import { trackEvent } from "~/mixpanel/trackEvent";
import { api } from "~/utils/api";
import { useRerouteIfAlreadyPremium } from "../components/Plans/useRerouteIfAlreadyPremium";

/** Provides a payment form for the user to upgrade to premium */
const Plans: NextPage = () => {
  const myPremiumMembershipQuery =
    api.memberships.myPremiumMembership.useQuery();
  const tiersQuery = api.memberships.getTiers.useQuery();

  useRerouteIfAlreadyPremium(
    myPremiumMembershipQuery.data?.premiumSubscription
  );

  if (myPremiumMembershipQuery.isLoading || tiersQuery.isLoading)
    return <Layout title="Premium Membership" isLoading />;

  return (
    <Layout
      error={
        tiersQuery.error?.message || myPremiumMembershipQuery.error?.message
      }
      title={<div className="text-center">Premium Membership</div>}
      description="Welcome to Imam Ibn al-Qayyim's Islamic Public Library, where we value your membership! Our premium membership not only grants you access to our physical library computers and wifi, but also unlocks exclusive benefits for our highest-tier members. Upgrade your membership today and unlock even more features that cater to your needs!"
      imgUrl="/img/holding-card.png"
    >
      <div className="flex flex-wrap items-stretch justify-center gap-6">
        {tiersQuery.data?.map((t) => (
          <TierMembershipOption tier={t} key={t.id} />
        ))}
      </div>
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  await trackEvent(ctx, EventNames.PLANS_PAGE_VIEWED);
  return { props: {} };
};

const PlansPage: NextPage = () => (
  <Private>
    <Plans />
  </Private>
);

export default PlansPage;
